frappe.provide("ikart.webshop");
frappe.provide("ikart.webshop.product_ui");
if (!frappe.boot) frappe.boot = {}

frappe.ready(() => {
	const bottomNav = document.querySelector(".imek-mobile-bottom-nav.imek-bottom-nav");
	if (bottomNav && bottomNav.parentElement !== document.body) {
		document.body.appendChild(bottomNav);
	}

	const searchBox = document.getElementById("search-box");
	const searchWrapper = document.getElementById("dropdownMenuSearch");
	const bottomNavLinks = document.querySelectorAll("[data-imek-bottom-nav-link]");
	const normalizePath = (path) => {
		const normalized = (path || "/").replace(/\/+$/, "");
		return normalized || "/";
	};

	if (
		searchBox
		&& searchWrapper
		&& !searchBox.dataset.imekProductSearchBound
		&& ikart.webshop.product_ui.ProductSearch
	) {
		searchBox.dataset.imekProductSearchBound = "1";
		new ikart.webshop.product_ui.ProductSearch({search_box_id: "#search-box"});
	}

	const sidebarLinks = Array.from(
		document.querySelectorAll(
			".web-sidebar a, .sidebar-column a, .page-sidebar a, .portal-sidebar a, .standard-sidebar a, .layout-side-section a"
		)
	).filter((link) => !link.closest(".imek-account-nav"));
	if (sidebarLinks.length) {
		const hiddenSidebarPaths = new Set(["/addresses", "/orders"]);
		sidebarLinks.forEach((link) => {
			const linkPath = normalizePath(new URL(link.href, window.location.origin).pathname);
			if (hiddenSidebarPaths.has(linkPath)) {
				const item = link.closest("li, .list-group-item, .web-sidebar-item") || link;
				item.classList.add("imek-hidden-account-sidebar-link");
				item.style.display = "none";
			}
		});
	}

	if (bottomNavLinks.length) {
		const currentPath = normalizePath(window.location.pathname);
		const currentParams = new URLSearchParams(window.location.search || "");
		const hasCategoryFilter = currentParams.has("webshop_category") || currentParams.has("item_group");
		const accountPaths = new Set(["/login", "/me", "/orders"]);
		const homePaths = new Set(["/", "/home"]);
		const categoryPaths = new Set(["/all-products", "/shop-by-category"]);
		const isHomePath = (path) => homePaths.has(path) && !(path === "/webshop" && hasCategoryFilter);
		const isCategoryPath = (path) => (
			categoryPaths.has(path)
			|| path.startsWith("/all-products/")
			|| path.startsWith("/shop-by-category/")
			|| path.startsWith("/category/")
			|| (path === "/webshop" && hasCategoryFilter)
		);

		bottomNavLinks.forEach((link) => {
			const linkPath = normalizePath(new URL(link.href, window.location.origin).pathname);
			const isActive = linkPath === currentPath
				|| (homePaths.has(linkPath) && isHomePath(currentPath))
				|| (linkPath === "/shop-by-category" && isCategoryPath(currentPath))
				|| (linkPath === "/cart" && currentPath === "/cart")
				|| (accountPaths.has(linkPath) && accountPaths.has(currentPath));

			link.classList.toggle("active", isActive);
			if (isActive) {
				link.setAttribute("aria-current", "page");
			} else {
				link.removeAttribute("aria-current");
			}
		});
	}

	const cartBadge = document.getElementById("imek-cart-count");
	if (cartBadge && window.localStorage) {
		const cartCount = localStorage.getItem("cart_count")
			|| localStorage.getItem("imek_cart_count")
			|| "0";
		cartBadge.textContent = cartCount === "0" ? "" : cartCount;
		cartBadge.setAttribute("data-count", cartCount);
		cartBadge.classList.toggle("hidden", cartCount === "0");
	}

	// Back-to-top: appears after ~1.5 screens of scrolling. Injected here so
	// every storefront/portal page gets it without template changes.
	if (!document.querySelector(".imek-back-to-top")) {
		const backToTop = document.createElement("button");
		backToTop.type = "button";
		backToTop.className = "imek-back-to-top";
		backToTop.setAttribute("aria-label", window.__ ? __("Back to top") : "Back to top");
		backToTop.innerHTML = `
			<svg viewBox="0 0 24 24" aria-hidden="true" fill="none"
				stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
				<path d="M12 19V5M5 12l7-7 7 7"/>
			</svg>
		`;
		document.body.appendChild(backToTop);

		backToTop.addEventListener("click", () => {
			const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
		});

		let backToTopTick = false;
		const updateBackToTop = () => {
			backToTopTick = false;
			backToTop.classList.toggle("visible", window.scrollY > window.innerHeight * 1.5);
		};
		window.addEventListener("scroll", () => {
			if (!backToTopTick) {
				backToTopTick = true;
				window.requestAnimationFrame(updateBackToTop);
			}
		}, { passive: true });
		updateBackToTop();
	}
});
